import { UnitStatusEnum } from '@/enums/UnitStatus';

import type { NumberRange } from '../NumberRange';

export type UnitsFilters = {
  selectedBedroomsCounts: number[];
  selectedFloorNo?: number;
  selectedLivingAreaRange?: NumberRange;
  selectedPriceRange?: NumberRange;
  selectedStatuses: UnitStatusEnum[];
};

export const DefaultUnitsFilters: UnitsFilters = Object.freeze({
  selectedBedroomsCounts: [],
  selectedFloorNo: undefined,
  selectedLivingAreaRange: undefined,
  selectedPriceRange: undefined,
  selectedStatuses: [],
});
